<p-toast  />
<div class="rating-popup">
    <p-dialog [(visible)]="ratingService.displayRating" [modal]="true"
        [showHeader]="false" [draggable]="false"
        [resizable]="false">
        <div>
        <form>
            <h1>Rate Us</h1>
                <p>How was your experience using our afterbricks? Your rating
                    matter!</p>
  
                <div class="rating">
                    <p-rating [(ngModel)]="ratingService.stars" (onRate)="ratingService.savedsampleRatingstars()"  [cancel]="false" name="something" />
                </div>
    <div class="rating-options" *ngIf="ratingService.loading">
         <!-- Skeleton Loader -->
     <div class="qs-row skeleton-loader" *ngFor="let i of [1,2,3]">
        <div class="skeleton-title"></div>
        <div class="ab-row" >
            <div class="ab-col" *ngFor="let i of [1,2,3]">
                <div class="field-radiobutton skeleton-radio">
                    <div class="skeleton-circle"></div>
                    <div class="skeleton-text"></div>
                </div>
            </div>
        </div>
    </div>
    </div>
                <div class="rating-options" *ngIf="!ratingService.loading">
                    <div class="qs-row"
                        *ngFor="let q of ratingService.ratingQuestionsAnswers">
                        <h5>{{ q.question_text }}</h5>
                        <div class="ab-row">
                            <label class="ab-col ab-cust-radio" *ngFor="let a of q.answers">
                                <div class="field-radiobutton">
                                    <input 
                                    type="radio"
                                    [(ngModel)]="ratingService.responses[q.id]"
                                    [name]="'question-' + q.id"
                                    [id]="'answer-' + a.id"
                                    [value]="a.response" />
                                <!-- <label [for]="'answer-' + a.id" class="ml-2">{{ a.response }}</label> -->
                                 <!-- <i class="pi pi-circle"></i> -->
                                <span class="radio-btn">
                                    <i class="pi pi-check-circle checked"></i>
                                    <i class="pi pi-circle un-checked"></i>
                                    <div class="hobbies-icon">
                                      <p>{{ a.response }}</p>
                                    </div>
                                  </span>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="textarea-group">
                    <label>
                        <span>Comment : </span>
                        <textarea id="comment-rating"
                            placeholder="Additional feedback ..."
                            name="feedback"
                            [(ngModel)]="ratingService.comment"></textarea>
                    </label>
                </div>
                <div class="p-footer">
                    <button class="close-r-btn"
            (click)="ratingService.displayRating = false" [ngClass]="{'is-submit':ratingService.inLineloading}">Cancel</button>
        <button class="submit-r-btn " type="submit" [ngClass]="{'is-submit':ratingService.inLineloading}" (click)="submitRating()" > <i *ngIf="ratingService.inLineloading" class="pi pi-spin pi-spinner" style="margin-right: 4px;"></i> Submit</button>
       
                </div>
        </form>
        </div>
    
    </p-dialog>
</div>

<div class="thanks-dialog">
    <p-dialog header="Edit Profile" [modal]="true"
        [(visible)]="ratingService.displayThankYou" [showHeader]="false">
        <div class="thanks-container">
            <img src="assets/images/icon/Check.svg" alt="Check ">
            <h3>Thanks you for your feedback!</h3>

            <p>We appreciate your feedback we'll use your feedback to improve
                your experience</p>

            <button (click)="doneRating()">Done</button>
        </div>
    </p-dialog>

</div>